"use client";
import AuthenticationControl from "@/components/menu/AuthenticationControl";
import { setShowAuthPrompt } from "@/data/redux/appSlice";
import { useAppDispatch, useAppSelector } from "@/data/redux/store";
import { AuthPromptType } from "@/data/types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

export default function AuthPrompt() {
  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.app.auth);

  const handleClose = () => {
    dispatch(setShowAuthPrompt(null));
  };

  const title = (() => {
    switch (authState.showPrompt) {
      case AuthPromptType.Like:
        return "Like this army book?";
      case AuthPromptType.Bookmark:
        return "Want to save this for later?";
      case AuthPromptType.Report:
        return "Need to report this book?";
    }
  })();

  const body = (() => {
    switch (authState.showPrompt) {
      case AuthPromptType.Like:
        return "Sign in to make your voice heard";
      case AuthPromptType.Bookmark:
        return "Sign in to add it to your bookmarks";
      case AuthPromptType.Report:
        return "Sign in to report inappropriate content";
    }
  })();

  return (
    <Dialog open={authState.showPrompt !== null} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{body}</Typography>
      </DialogContent>
      <DialogActions sx={{ pr: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <AuthenticationControl />
      </DialogActions>
    </Dialog>
  );
}
